module.exports = __webpack_public_path__ + "img/bwzytw-currency-guide.46270a43.png";